import _ from "lodash";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AppError from "../../services/appError";
import { HttpCodes } from "../../constants/app.constant";

export interface ErrorState {
  error?: Error;
}

const initialState: ErrorState = {
  error: undefined
};

export const handleError = createAsyncThunk(
  "error/handle",
  (error: Error, thunkApi) => {
    console.error("Handling error:");
    console.error(error, error.stack);

    let httpStatus;

    if (error instanceof AppError) {
      let sourceError: Error | undefined = error.sourceError;
      if (sourceError) {
        console.error("Source error:");
        console.error(sourceError, sourceError.stack);
      }
      httpStatus = _.get(error, "sourceError.response.status");
    } else {
      httpStatus = _.get(error, "response.status");
    }

    const { dispatch } = thunkApi;

    dispatch(setError(error));

    if (
      httpStatus == HttpCodes.UNAUTHORIZED ||
      httpStatus == HttpCodes.FORBIDDEN
    ) {
      // TODO: Goto Forbidden Page
    } else {
      // TODO: Goto error page
    }
  }
);

export const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setError } = errorSlice.actions;

export default errorSlice.reducer;
